import { ShiftTypeId } from "../../@client/Absents"
import { ShiftTypeDto } from "../../@client/Theasoft_ApiServer_ShiftTypes"
import { useSuspenseQueryGet } from "../../typed-client/hooks/use-suspense-query-get"
import { Text } from "@mantine/core"

export function RenderShiftType({
  id,
  children,
  notFound,
}: {
  id: ShiftTypeId
  notFound?: React.ReactNode
  children: (item: ShiftTypeDto) => React.ReactNode
}) {
  const data = useSuspenseQueryGet("/api/ShiftType/GetShiftTypes", null, {
    gcTime: Infinity,
    staleTime: Infinity,
  })

  const shiftType = data.data.find((st) => st.shiftTypeId === id)
  if (!shiftType) {
    return notFound ? (
      notFound
    ) : (
      <Text c="red" fw={550}>
        Shifttype '{id}' not found
      </Text>
    )
  }
  return children(shiftType)
}
